import { Link } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// import Swiper core and required modules & Pagination
import SwiperCore, { Autoplay, Navigation } from "swiper/core";
import { TramOutlined } from "@mui/icons-material";
import { useRef } from "react";
import "./styles.css";
import { useDispatch } from "react-redux";
import { addProduct } from "../../redux/cartSlice";

SwiperCore.use([Navigation]);

export default function App({ products, title }) {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const dispatch = useDispatch()

  return (
    <>
      <div className="nav flex justify-between mt-8 items-center">
        <h2 className="text-lg text-secondary font-Roboto font-medium my-2">
          {title}
        </h2>
        <div className="flex justify-center items-center gap-8">
          <div
            ref={prevRef}
            className="h-5 w-5 text-secondary cursor-pointer hover:text-secondary-50 drop-shadow-md flex justify-center items-center"
          >
            <ChevronLeftIcon fontSize={"large"} />
          </div>
          <div
            ref={nextRef}
            className="h-5 w-5 text-secondary cursor-pointer hover:text-secondary-50 drop-shadow-md flex justify-center items-center"
          >
            <ChevronRightIcon fontSize={"large"} />
          </div>
        </div>
      </div>
      <Swiper
        modules={[Autoplay]}
        onInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
          swiper.navigation.init();
          swiper.navigation.update();
        }}
        slidesPerView={4}
        slidespercolumn={1}
        autoplay={true}
        rewind={TramOutlined}
        spaceBetween={30}
        // pagination={{ clickable: true }}

        breakpoints={{
          // when window width is >= 320px
          320: {
            slidesPerView: 2,
            spaceBetween: 8,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 2,
            spaceBetween: 8,
          },
          512: {
            slidesPerView: 3,
            spaceBetween: 8,
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
        }}
        className="mySwiper"
      >
        <div
        className="cards container w-full mb-4 grid grid-cols-4 gap-8 justify-items-center">
          {products?.map((product) => (
            <SwiperSlide key={product._id}>
              <div className="card flex flex-col w-40 md:w-64  bg-gray-50 shadow-md rounded-md overflow-hidden">
                <Link to={"product/" + product._id}>
                  <div className="imgBox h-28 md:h-44 w-full object-cover relative">
                    <p className="brand text-sm text-gray-300 font-medium drop-shadow-md absolute top-0.5 left-1 z-10">
                      {product.brand}
                    </p>
                    <img
                      className="h-full w-full object-cover"
                      src={product.image}
                      alt="product"
                    />
                  </div>
                  <div className="info flex justify-between my-2 px-1">
                    <div className="container">
                      <h3 className="text-xs md:text-base text-gray-700 font-Roboto font-medium text-start">
                      {product.title.length >19 ? product.title.substr(0, 18)+".." : product.title }
                      </h3>
                      <div className="text-xs mt-1 text-gray-400 font-Roboto font-medium flex items-center">
                        color:
                        {product.color.map((c, index) => (
                          <span key={c + index }
                            style={{ backgroundColor: c }}
                            className="w-4 h-4 rounded-full mx-1 drop-shadow-md"
                          ></span>
                        ))}
                      </div>
                    </div>
                    <h3 className="text-xs md:text-base text-gray-700 font-Roboto font-medium">
                      ${product.price}
                    </h3>
                  </div>
                </Link>
                <button onClick={()=> dispatch(addProduct({ ...product, quantity: 1 })) }
                 className="p-1 w-full bg-primary text-white text-sm font-Roboto font-normal md:text-lg md:font-medium hover:bg-primary-200 transition-all">
                  Add to bag
                </button>
              </div>
            </SwiperSlide>
          ))}
        </div>
      </Swiper>
    </>
  );
}
